import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const serviceExpertComptable = {
	associatedRule:
		"indépendant . profession libérale . réglementée . métier = 'expert-comptable'",
	url: 'https://www.urssaf.fr/accueil/services/services-tiers-declarants/service-expert-comptable.html',
	title: 'Le service en ligne Expert-comptable',
	description:
		'L’Urssaf met à votre disposition un service en ligne. Il vous permet de gérer votre activité, contacter un conseiller et retrouver tous vos documents.',
	ctaLabel: 'Accéder au service',
	ariaLabel: 'Accéder au service sur urssaf.fr, nouvelle fenêtre',
	logo: URSSAF,
}
